import Vue from 'vue';
import Vuetify from 'vuetify';
import VueI18n from 'vue-i18n';
import VueProgressBar from 'vue-progressbar';

// LOCAL
import App from '@/App';
import router from '@/router';
import store from '@/store';

// Plugins
import EventBus from '@/common/plugins/event-bus';
import Util from '@/common/plugins/util';
import Storage from '@/common/plugins/storage';
import Message from '@/common/plugins/message/message';
import Loading from '@/common/plugins/loading/loading';
import Service from '@/common/plugins/service';
import Modal from '@/common/plugins/modal/modal';
import Datetime from '@/common/plugins/datetime';
import Filter from '@/common/plugins/filter';
import messages from '@/common/lang/';

// Vendor
Vue.use(Vuetify, {
  theme: {
    primary: '#0f6a95',
    secondary: '#ffffff',
    info: '#36a3f7',
    warning: '#ffb822',
    error: '#f4516c',
    success: '#34bfa3'
  }
});
Vue.use(VueProgressBar, {
  color: '#52d1e1',
  failedColor: '#fc4b6c',
  thickness: '4px'
});

// i18n config
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: process.env.LANG,
  messages
});

// Store Vuex
Vue.use(store);

// Plugins config
Vue.use(EventBus);
Vue.use(Util);
Vue.use(Storage, { appName: 'apostilla' });
Vue.use(Message, { timeout: 6000 });
Vue.use(Loading);
Vue.use(Service, {
  apiUrl: process.env.API_URL,
  graphqlUrl: process.env.GRAPHQL_URL,
  authUrl: process.env.AUTH_URL,
  authToken: process.env.AUTH_TOKEN,
  filterResponse: (response, Message) => {
    if (response.data && response.code === 1) {
      response = response.data;
    } else {
      if (response.code === -1) {
        Message.error(response.message);
        return null;
      } else if (response.code === 0) {
        Message.warning(response.message);
        return null;
      }
    }
    return response;
  },
  errorFormat: 'message'
});
Vue.use(Modal);
Vue.use(Datetime);
Vue.use(Filter);

Vue.config.productionTip = false;
Vue.config.debug = process.env.DEBUG_MODE;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js